import { jsx, Fragment } from "react/jsx-runtime";
import { forwardRef, createElement, cloneElement, Children } from "react";
import stitches from "../theme.config.es.js";
import { isLink, isAnchor } from "./utils.es.js";
import { clsx } from "../../utils/mergeProps.es.js";
import { spacing } from "../../themes/tokens/spacing.es.js";
import { color } from "../../themes/tokens/color.es.js";
function getWrappedElement(children) {
  return typeof children === "string" ? /* @__PURE__ */ jsx("span", { role: "link", tabIndex: 0, children }) : Children.only(children);
}
const focusStyles = {
  outlineOffset: "2px"
};
const underlineStyles = {
  textDecorationLine: "underline",
  textDecorationThickness: "2px",
  textUnderlineOffset: spacing["spacing-1"].value
};
const styles = stitches.css({
  fontFamily: "$defaultFont",
  variants: {
    use: {
      primary: {
        color: color["color-interactive-default"].value,
        cursor: "pointer",
        textDecorationLine: "none",
        "&:focus": focusStyles,
        "&:hover": { color: color["color-interactive-hovered"].value },
        "&:active, &:visited": { color: color["color-interactive-visited"].value },
        "&:hover, &:active, &:visited": underlineStyles
      },
      secondary: {
        color: color["color-text-subtle"].value,
        cursor: "pointer",
        textDecorationLine: "none",
        "&:focus": focusStyles,
        "&:hover": { color: color["color-text-default"].value },
        "&:active, &:visited": { color: color["color-interactive-visited"].value },
        "&:hover, &:active, &:visited": underlineStyles
      },
      contrast: {
        color: color["color-text-contrast"].value,
        cursor: "pointer",
        textDecorationLine: "none",
        "&:focus": focusStyles,
        "&:hover, &:active, &:visited": underlineStyles
      },
      reset: {
        color: "inherit",
        textDecoration: "none"
      }
    },
    underline: {
      true: {
        textDecorationLine: "underline",
        textUnderlineOffset: spacing["spacing-1"].value
      }
    }
  }
});
const EzLink = forwardRef(function EzLink2(props, ref) {
  const {
    as = "span",
    children,
    className,
    underline,
    use = "primary",
    ...passThroughProps
  } = props;
  let content = children;
  if (isLink(passThroughProps)) {
    const options = passThroughProps;
    const type = options.href ? "a" : as;
    content = createElement(type, options, children);
  }
  const el = getWrappedElement(content);
  return /* @__PURE__ */ jsx(Fragment, { children: cloneElement(el, {
    ref: el.ref || ref,
    className: clsx(styles({ use, underline }), className, el.props.className),
    ...passThroughProps
  }) });
});
const Link = forwardRef(function Link2(props, ref) {
  if (isAnchor(props)) {
    return /* @__PURE__ */ jsx("a", { ...props, ref, children: props.children });
  }
  const { as: Component, ...rest } = props;
  const LinkComponent = Component;
  return /* @__PURE__ */ jsx(LinkComponent, { ref, ...rest });
});
EzLink.displayName = "EzLink";
export {
  Link,
  EzLink as default
};
//# sourceMappingURL=EzLink.es.js.map
